class WearableGallery {
  constructor(el) {
    this.el = el;
    this.spacer = el.querySelector('.wearable-gallery__spacer');
    this.strip = el.querySelector('.wearable-gallery__strip');
    this.items = Array.from(el.querySelectorAll('.wearable-gallery__item'));
    this.itemCount = this.items.length;
    this.thumbMoves = Array.from(el.querySelectorAll('.wearable-gallery__thumbs-move'));
    this.ticking = false;
    this.lastActiveIndex = -1;

    if (this.itemCount === 0) return;

    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize);

    this.measure();
    this.update();
  }

  measure() {
    this.itemWidth = this.items[0].getBoundingClientRect().width;

    const firstMove = this.thumbMoves[0];
    if (firstMove) {
      const firstThumb = firstMove.querySelector('.wearable-gallery__thumb-item');
      if (firstThumb) {
        const gap = parseFloat(getComputedStyle(firstMove).gap || 0);
        this.thumbStep = firstThumb.getBoundingClientRect().width + gap;
      }
    }
  }

  onResize() {
    this.measure();
    this.update(true);
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(() => {
      this.update();
      this.ticking = false;
    });
  }

  update(force) {
    const rect = this.spacer.getBoundingClientRect();
    const scrollableDistance = this.spacer.offsetHeight - window.innerHeight;
    let progress = scrollableDistance > 0 ? -rect.top / scrollableDistance : 0;
    progress = Math.min(1, Math.max(0, progress));

    const rawIndex = progress * (this.itemCount - 1);

    // main strip: continuous slide, one item exactly fills the window
    const mainTranslateX = -rawIndex * this.itemWidth;
    this.strip.style.transform = `translate3d(${mainTranslateX}px, 0, 0)`;

    // both thumb tracks share the exact same offset —
    // the left track's own CSS anchor (left:100%) is what delays its reveal
    if (this.thumbStep) {
      const thumbTranslateX = -rawIndex * this.thumbStep;
      this.thumbMoves.forEach((move) => {
        move.style.transform = `translate3d(${thumbTranslateX}px, -50%, 0)`;
      });
    }

    const activeIndex = Math.round(rawIndex);
    if (activeIndex !== this.lastActiveIndex || force) {
      this.items.forEach((item) => {
        if (item.dataset.type !== 'video') return;
        const video = item.querySelector('video');
        if (!video) return;
        const index = Number(item.dataset.index);
        if (index === activeIndex) {
          video.currentTime = 0;
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
      this.lastActiveIndex = activeIndex;
    }
  }
}

function initWearableGalleries() {
  document.querySelectorAll('.wearable-gallery').forEach((el) => {
    if (!el.dataset.initialized) {
      new WearableGallery(el);
      el.dataset.initialized = 'true';
    }
  });
}

document.addEventListener('DOMContentLoaded', initWearableGalleries);
document.addEventListener('shopify:section:load', initWearableGalleries);